import { createContext } from 'react';
const MusteriContext = createContext(null);
export default MusteriContext;